const REGEX = /^\d+\.\d+\.\d+$/;

export const normalizeVersion = (str) => {
  if (str == null) return null;
  const trimmed = String(str).trim();
  if (trimmed === "") return null;
  if (REGEX.test(trimmed)) return trimmed;
  const parts = trimmed.split(/[.]/);
  const firstNum = parseInt(parts[0], 10);
  if (!Number.isFinite(firstNum)) return null;
  const nums = parts.map((p) => {
    const n = parseInt(p, 10);
    return Number.isFinite(n) && n >= 0 ? n : 0;
  });
  while (nums.length < 3) nums.push(0);
  return `${nums[0]}.${nums[1]}.${nums[2]}`;
};

export const bumpPatch = (version) => {
  if (!version) return "0.0.1";
  const parts = String(version).split(/[.]/);
  const major = parseInt(parts[0], 10) || 0;
  const minor = parseInt(parts[1], 10) || 0;
  const patch = (parseInt(parts[2], 10) || 0) + 1;
  return `${major}.${minor}.${patch}`;
};

export const suggestNext = (currentVersion) => {
  const normalized = normalizeVersion(currentVersion);
  return bumpPatch(normalized || "0.0.0");
};

export const versionBadgeKey = (version) => {
  const normalized = normalizeVersion(version);
  if (!normalized) return "none";
  const parts = normalized.split(".");
  if ((parseInt(parts[0], 10) || 0) > 0) return "major";
  if ((parseInt(parts[1], 10) || 0) > 0) return "minor";
  return "patch";
};

export const SEMVER_BADGE_COLORS = {
  major: "dangerColor",
  minor: "warningColor",
  patch: "success",
  none: "mediumGrey",
};

export const getBadgeColor = (version) =>
  SEMVER_BADGE_COLORS[versionBadgeKey(version)] ||
  SEMVER_BADGE_COLORS.none;

export default {
  normalizeVersion,
  bumpPatch,
  suggestNext,
  versionBadgeKey,
  getBadgeColor,
  SEMVER_BADGE_COLORS,
};